import script from "./StagingBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./StagingBanner.vue?vue&type=script&setup=true&lang=ts"

import "./StagingBanner.vue?vue&type=style&index=0&id=114bb561&scoped=true&lang=scss"
import "./StagingBanner.vue?vue&type=style&index=1&id=114bb561&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_typescript@5.4.5__webpack@5.104.1_esbuild@0.28.2_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114bb561"]])

export default __exports__